<template>
  <div v-if="ranges.length" class="ranges">
    <div v-for="range in ranges" :key="range.label" class="ranges__item">
      <span class="ranges__label">{{ range.label }}</span>
      <div class="ranges__scale">
        <span class="ranges__end">{{ format(range.low) }}</span>
        <span class="ranges__track">
          <span v-if="range.current != null" class="ranges__marker" :style="{ left: `${position(range)}%` }"></span>
        </span>
        <span class="ranges__end">{{ format(range.high) }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { money } from "@/utils/exchange.js";

/**
 * Low-to-high ranges with where today's price sits in each: the day's range, the 52-week range.
 * Each range is { label, low, high, current? }; a range with nothing between its ends is left out.
 */
export default {
  name: "RangeBars",
  props: {
    rows: { type: Array, default: () => [] },
    currency: { type: String, default: "NGN" },
    decimals: { type: Number, default: 2 },
  },
  computed: {
    ranges() {
      return this.rows.filter((r) => r && Number(r.high) > Number(r.low));
    },
  },
  methods: {
    format(value) { return money(value, this.currency, this.decimals); },
    position(range) {
      const p = ((Number(range.current) - Number(range.low)) / (Number(range.high) - Number(range.low))) * 100;
      return Math.min(100, Math.max(0, p));
    },
  },
};
</script>

<style lang="scss" scoped>
$text-primary: #0f172a;
$text-secondary: #475569;
$border-color: #e2e8f0;
$btn-primary: #001240;

.ranges {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 16px;
  border-top: 1px solid $border-color;
  margin-top: 14px;
  padding-top: 14px;

  &__label { display: block; font-size: 12px; color: $text-secondary; margin-bottom: 6px; }

  &__scale { display: flex; align-items: center; gap: 10px; }

  &__end { font-size: 13px; font-weight: 600; color: $text-primary; white-space: nowrap; }

  &__track {
    position: relative;
    flex: 1;
    height: 6px;
    border-radius: 3px;
    background: linear-gradient(90deg, rgba(77, 132, 255, 0.2), rgba(77, 132, 255, 0.55));
  }

  &__marker {
    position: absolute;
    top: 50%;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: $btn-primary;
    border: 2px solid #ffffff;
    transform: translate(-50%, -50%);
    box-shadow: 0 0 0 1px $btn-primary;
  }
}
</style>
